import { FC } from "react";
import { ButtonTitle, Icon } from "../Button.styled";
import { arrow } from "../../../assets/icon";
import { TextConfig } from "../../../providers/QuizProvider/QuizContext";
import { getStyleFromTextConfig } from "../../../utils/style";

type Props = {
  isHideArrow: boolean;
  title?: string | null;
  titleConfig?: TextConfig;
};

export const ButtonContent: FC<Props> = ({
  isHideArrow,
  title,
  titleConfig,
}) => {
  const style = titleConfig ? getStyleFromTextConfig(titleConfig) : {};
  if (!isHideArrow) style.marginRight = "15px";
  return (
    <>
      {title && <ButtonTitle style={style}>{title}</ButtonTitle>}
      {!isHideArrow && <Icon src={arrow} />}
    </>
  );
};
